/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"GenericAcceptPolicy":"GenericAcceptPolicy_45tPi","checkbox":"checkbox_+SOfM","text":"text_6HRmD"};